import { RestrictionType } from '@tiendanube/common/src/enums/RestrictionType';
import { COUNTRIES_WITH_GEOLOCATION_INFO } from 'domains/Shipping/utils';

export const getRestrictionTypeOptions = (country: string) => {
  const baseOptions = [
    {
      label: 'options.allCountry',
      value: RestrictionType.COUNTRY,
    },
    {
      label: 'options.byZones',
      value: RestrictionType.AREA,
    },
  ];

  if (COUNTRIES_WITH_GEOLOCATION_INFO.has(country)) {
    return [
      ...baseOptions,
      {
        label: 'options.byRanges',
        value: RestrictionType.DISTANCE,
      },
    ];
  }

  return baseOptions;
};
